(function () {
  if (window.hkVideoLightbox) return;
  window.hkVideoLightbox = true;

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function pauseAll(root) {
    (root || document).querySelectorAll('.hk-pswp-video video').forEach(function (v) { if (!v.paused) v.pause(); });
  }

  function patch() {
    var P = window.theme && window.theme.Photoswipe;
    if (!P) return false;
    if (P.prototype._hkPatched) return true;
    P.prototype._hkPatched = true;

    // Build the lightbox list from images AND inline videos, in page order.
    P.prototype.getImageData = function () {
      var sel = this.inSlideshow
        ? '.flickity-viewport .photoswipe__image, .flickity-viewport video[data-hk-autoplay]'
        : '.photoswipe__image, video[data-hk-autoplay]';
      this.images = this.container.querySelectorAll(sel);
      var items = [];
      this.images.forEach(function (el) {
        if (el.tagName === 'VIDEO') {
          var src = el.getAttribute('data-hk-video-src') || (el.querySelector('source') || {}).src;
          items.push({
            el: el,
            hkVideo: true,
            html: '<div class="hk-pswp-video"><video playsinline controls loop controlslist="nodownload" preload="auto" poster="' +
              esc(el.getAttribute('poster')) + '" src="' + esc(src) + '"></video></div>'
          });
        } else {
          items.push({
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          });
        }
      });
      return items;
    };

    // Open on a specific video when a video was tapped.
    var origTrigger = P.prototype.triggerClick;
    P.prototype.triggerClick = function (evt) {
      var target = this.container._hkOpenEl;
      this.container._hkOpenEl = null;
      if (!target) return origTrigger.call(this, evt);
      this.inSlideshow = !!(this.container.dataset && this.container.dataset.hasSlideshow === 'true');
      this.items = this.getImageData();
      var idx = 0;
      for (var i = 0; i < this.items.length; i++) { if (this.items[i].el === target) { idx = i; break; } }
      this.initGallery(this.items, idx + 1);
    };

    // Keep taps on a video from closing the lightbox, and play only the video on screen.
    var origInit = P.prototype.initGallery;
    P.prototype.initGallery = function (items, index) {
      var RealPS = window.PhotoSwipe;
      window.PhotoSwipe = function (el, ui, its, opts) {
        opts = opts || {};
        opts.clickToCloseNonZoomable = false;
        return new RealPS(el, ui, its, opts);
      };
      try { origInit.call(this, items, index); } finally { window.PhotoSwipe = RealPS; }

      var gallery = this.gallery;
      if (!gallery) return;
      var sync = function () {
        var root = document.querySelector('.pswp');
        pauseAll(root);
        var item = gallery.currItem;
        if (item && item.hkVideo && item.container) {
          var v = item.container.querySelector('video');
          if (v) {
            v.muted = false;
            var p = v.play();
            if (p && p.catch) p.catch(function () { v.muted = true; var q = v.play(); if (q && q.catch) q.catch(function () {}); });
          }
        }
      };
      gallery.listen('afterChange', sync);
      gallery.listen('initialZoomInEnd', sync);
      gallery.listen('close', function () { pauseAll(document.querySelector('.pswp')); });
      gallery.listen('destroy', function () { pauseAll(document.querySelector('.pswp')); });
    };
    return true;
  }

  // Tapping an inline product video opens the full-screen gallery on that video.
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest && e.target.closest('.product__video-wrapper');
    if (!wrap) return;
    var video = wrap.querySelector('video[data-hk-autoplay]');
    if (!video) return;
    var container = wrap.closest('[data-zoom="true"]');
    if (!container) return;
    var trigger = container.querySelector('.js-photoswipe__zoom');
    if (!trigger || !patch()) return;
    e.preventDefault();
    // The theme opens the gallery on the selected slide, so make sure the tapped video's slide is selected.
    var slide = video.closest('.product-main-slide');
    var track = slide && slide.closest('.flickity-enabled');
    var flick = track && window.Flickity && window.Flickity.data(track);
    if (flick && slide.getAttribute('data-index') != null) {
      var i = parseInt(slide.getAttribute('data-index'), 10);
      if (!isNaN(i) && flick.selectedIndex !== i) flick.select(i, false, true);
    }
    container._hkOpenEl = video;
    trigger.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
})();
